import React, { useState, useEffect } from "react";
import "./NewEntryModal.css"; // Ensure you have this CSS file

const NewEntryModal = ({ customers, onSubmit, onClose }) => {
  const [entryData, setEntryData] = useState({
    partyName: "",
    invoice: "",
    dateOfDispatch: "",
    modeOfTransport: "",
    transportCourierName: "",
    docketGrNo: "",
    valueOfGoods: "",
    noOfCases: "",
    imageOfBuilty: "",
  });

  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [imageFile, setImageFile] = useState(null);

  const transportCourierOptions = [
    "A ONE TPT",
    "A.D ROADLINES TPT",
    "ALL UP INDIA TPT",
    "ANAND ROADLINES TPT",
    "ANJANI",
    "ARC TPT",
    "ATC TPT",
    "ATUL GOODS TPT",
    "BALUNI CARGO TPT",
    "BHAGIRATH TPT",
    "BLUE DART",
    "BOMBAY DELHI TPT",
    "CHAMBA SHIMLA TPT",
    "CTS TPT",
    "DASH LOGISTICS TPT",
    "DELHI CHD TPT",
    "DELHI RAJASTHAN TPT",
    "DELHI SHIMLA TPT",
    "DELHI UP MP TPT",
    "DELHIVERY",
    "DOABA ROADWAYS TPT",
    "DTDC",
    "DTDC BY AIR",
    "FLYING CARGO TPT",
    "FLYING GOODS",
    "GARG ROADLINE TPT",
    "GATI TPT",
    "GOLDEN ROADWAYS TPT",
    "GOYAL GOODS TPT",
    "GREAT INDIA TPT",
    "H.G.C TPT",
    "HARYANA FREIGHT TPT",
    "HIMALAYA TPT",
    "HINDUSTAN GOODS TPT",
    "INDIA NEPAL TPT",
    "INDO NEPAL TPT",
    "INDORE CHD TPT",
    "INDORE TPT",
    "JAI AMBEY TPT",
    "JAI LOGISTICS TPT",
    "JAI MATA DI TPT",
    "JAIPUR GOLDEN TPT",
    "JAIPUR SHIMLA TPT",
    "JETLINE",
    "JHELUM ROADWAYS TPT",
    "KANPUR DELHI TPT",
    "KHUSHDIL TPT",
    "MAA ANNAPURNA TPT",
    "MADHUR",
    "MIGLANI TPT",
    "NAGPUR GOLDEN TPT",
    "NAVIN XPS TPT",
    "NECC TPT",
    "NEW MIGLANI ROADWAYS TPT",
    "NEW SHIV SHAKTI LOGISTICS  TPT",
    "NIRMAN GOODS",
    "NITCO TPT",
    "OM LOGISTICS TPT",
    "ON DOT",
    "PROFESSIONAL",
    "PROFESSIONAL BY AIR",
    "RAJKAMAL TPT",
    "RIVIGO BY MAHINDRA LOGISTICS TPT",
    "S K ROADLINE TPT",
    "SAFEXPRESS TPT",
    "SHIV SHAKTI TPT",
    "SHREE AZAD TPT",
    "SHREE JMD TPT",
    "SHREE MARUTI",
    "SHRI JMD TPT",
    "SIKKIM TPT",
    "SKRL TPT",
    "SKYKING",
    "SRI KRISHNA LOGISTICS TPT",
    "SUGAM TPT",
    "SUPER LOGISTICS TPT",
    "SURAJ TPT",
    "SURJIT TPT",
    "TCI EXPRESS",
    "TCI FREIGHT",
    "THE PUNJAB TPT",
    "TIRUPATI",
    "TRACKON",
    "TRACKON BY AIR",
    "TRACKON CARGO",
    "TRANS ROAD LOGISTICS TPT",
    "VINAY ROADLINE TPT",
    "VRL TPT",
    "VS LOGISTICS TPT",
  ];

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImageFile(e.target.files[0]);
    }
  };

  useEffect(() => {
    // Automatically calculate the default date of dispatch as the previous working day
    const calculateDefaultDateOfDispatch = () => {
      const today = new Date();
      let defaultDate = new Date();

      if (today.getDay() === 1) {
        // If today is Monday
        defaultDate.setDate(today.getDate() - 2); // Set to Saturday
      } else if (today.getDay() === 0) {
        // If today is Sunday
        defaultDate.setDate(today.getDate() - 1); // Set to Saturday
      } else {
        defaultDate.setDate(today.getDate() - 1); // Set to the previous day for other days
      }

      // Format the date as YYYY-MM-DD
      const formattedDate = defaultDate.toISOString().slice(0, 10);
      return formattedDate;
    };

    const defaultDateOfDispatch = calculateDefaultDateOfDispatch();

    setEntryData((prevEntryData) => ({
      ...prevEntryData,
      dateOfDispatch: defaultDateOfDispatch,
    }));

    // Fetch customers and other initializations remain the same
    setFilteredCustomers(customers);
  }, [customers]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEntryData({ ...entryData, [name]: value });
  };

  const handlePartyNameChange = (e) => {
    handleChange(e);
    const input = e.target.value.toLowerCase();
    const filtered = customers.filter(
      (customer) =>
        customer &&
        customer.customer_name &&
        customer.customer_name.toLowerCase().includes(input)
    );
    setFilteredCustomers(filtered);
    setIsDropdownVisible(input.length > 0 && filtered.length > 0); // Show dropdown if input is not empty and there are matches
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("partyName", entryData.partyName);
    formData.append("invoice", entryData.invoice);
    formData.append("dateOfDispatch", entryData.dateOfDispatch);
    formData.append("modeOfTransport", entryData.modeOfTransport);
    formData.append("transportCourierName", entryData.transportCourierName);
    formData.append("docketGrNo", entryData.docketGrNo);
    formData.append("valueOfGoods", entryData.valueOfGoods);
    formData.append("noOfCases", entryData.noOfCases);
    if (imageFile) {
      formData.append("imb", imageFile);
    }

    try {
      // Assuming onSubmit is the prop passed to handle FormData and communicate with backend
      await onSubmit(formData); // Adjust the backend endpoint accordingly
      setImageFile(null);
      // Reset the form here if necessary
      onClose(); // Close the modal after submission
    } catch (error) {
      console.error("Failed to submit new dispatch entry", error);
      // Handle error, possibly showing a message to the user
    }
  };

  return (
    <div className="new-entry-modal">
      <div className="modal-content">
        <span className="close-button" onClick={onClose}>
          &times;
        </span>
        <h2>New Dispatch Entry</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="partyName"
              value={entryData.partyName}
              onChange={handlePartyNameChange}
              placeholder="Party Name"
              autoComplete="off"
              required
            />
            {entryData.partyName && isDropdownVisible && (
              <ul className="customer-dropdown">
                {filteredCustomers.map((customer) => (
                  <li
                    key={customer.id}
                    onClick={() => {
                      setEntryData({
                        ...entryData,
                        partyName: customer.customer_name,
                      });
                      setIsDropdownVisible(false); // Hide dropdown after selection
                    }}
                  >
                    {customer.customer_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <input
            type="text"
            name="invoice"
            value={entryData.invoice}
            onChange={handleChange}
            placeholder="Invoice Number"
            required
          />
          <input
            type="date"
            name="dateOfDispatch"
            value={entryData.dateOfDispatch}
            onChange={handleChange}
            placeholder="Date of Dispatch"
            required
          />
          <select
            name="modeOfTransport"
            value={entryData.modeOfTransport}
            onChange={handleChange}
            required
          >
            <option value="">Select Mode of Transport</option>
            <option value="Courier">Courier</option>
            <option value="Transport">Transport</option>
          </select>
          <input
            list="transportCourierNames"
            name="transportCourierName"
            value={entryData.transportCourierName}
            onChange={handleChange}
            placeholder="Enter or select a Transport/Courier Name"
            required
          />
          <datalist id="transportCourierNames">
            {transportCourierOptions.map((option, index) => (
              <option key={index} value={option} />
            ))}
          </datalist>
          <input
            type="text"
            name="docketGrNo"
            value={entryData.docketGrNo}
            onChange={handleChange}
            placeholder="Docket/GR No."
            required
          />
          <input
            type="number"
            name="valueOfGoods"
            value={entryData.valueOfGoods}
            onChange={handleChange}
            placeholder="Value of Goods"
            onWheel={(e) => e.target.blur()}
            required
          />
          <input
            type="number"
            name="noOfCases"
            value={entryData.noOfCases}
            onChange={handleChange}
            placeholder="No. of Cases"
            onWheel={(e) => e.target.blur()}
            required
          />
          <input
            type="file"
            name="imageOfBuilty"
            onChange={handleImageChange}
            accept="image/png, image/jpeg, image/jpg"
          />
          {/* Assume 'imageOfBuilty' will be handled differently due to file input */}
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default NewEntryModal;
